import React from 'react';
import { Box } from '@mui/material';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { TextFormField } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/TextFormField';

export const ArrearsFlyoutField = ({
  label,
  value,
  isReadOnly = true
}: {
  label: string;
  value: any;
  isReadOnly?: boolean;
}) => {
  return (
    <Box display="flex" flexDirection="column" gap="8px" flex="1">
      <Body size={'smallBold'}>{label}</Body>
      <TextFormField
        defaultValue={value}
        disabled={isReadOnly}
        inputProps={{
          'aria-label': label
        }}
      />
    </Box>
  );
};
